function shareCurrentPage() {
  const pageTitle = document.title;
  const pageUrl = window.location.href;

  navigator
    .share({
      title: pageTitle,
      url: pageUrl,
    })
    .catch(console.error);
}

function updateCartIconsBasedOnCartContents() {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      console.log('Cart loaded:');
      const cartProductIds = cart.items.map((item) => item.product_id);
      document.querySelectorAll('[data-product-id]').forEach((button) => {
        const productId = parseInt(button.getAttribute('data-product-id'));
        const iconDefault = button.querySelector('.icon-cart-default');
        const iconFull = button.querySelector('.icon-cart-full');
        if (cartProductIds.includes(productId)) {
          if (iconDefault) iconDefault.classList.add('hidden');
          if (iconFull) iconFull.classList.remove('hidden');
        } else {
          if (iconDefault) iconDefault.classList.remove('hidden');
          if (iconFull) iconFull.classList.add('hidden');
        }
      });
    });
}

document.addEventListener('DOMContentLoaded', function () {
  updateCartIconsBasedOnCartContents();
});
